import { getTrackBackground } from 'react-range';
import theme from '@styles/theme';
export default {
  filterContainer: (dropdown: boolean) => ({
    mb: dropdown ? '' : '44px'
  }),
  inputContainer: {
    display: 'flex'
  },
  numberInput: (hasError: boolean) => ({
    height: '32px',
    textAlign: 'center',
    maxWidth: '100px',
    minWidth: '85px',
    fontSize: theme.fontSizes.smallText,
    border: `1px solid ${hasError ? theme.rawColors.accent700 : theme.rawColors.darkGrey300} `
  }),
  dash: {
    position: 'relative',
    display: 'flex',
    minWidth: '40px',
    justifyContent: 'center',
    alignItems: 'center',
    flex: 1,
    '&:after': {
      content: '""',
      position: 'absolute',
      width: '20px',
      height: '1px',
      background: theme.rawColors.neutralBlack
    }
  },
  unit: {
    fontSize: '12px',
    display: 'inline-flex',
    alignItems: 'center',
    mx: '8px',
    color: theme.rawColors.darkGrey500
  },
  rangeError: {
    color: theme.rawColors.accent700
  },
  trackContainer: style => ({
    ...style,
    height: '24px',
    display: 'flex',
    width: '100%',
    mt: '20px',
    mb: '40px'
  }),
  track: (value, defaultValue) => ({
    height: '2px',
    width: '100%',
    borderRadius: '4px',
    background: getTrackBackground({
      values: value,
      colors: [theme.rawColors.lightGrey500, theme.rawColors.accent700, theme.rawColors.lightGrey500],
      min: defaultValue.min,
      max: defaultValue.max
    }),
    alignSelf: 'center'
  }),
  thumb: (style, isDragged) => ({
    ...style,
    height: '24px',
    width: '24px',
    borderRadius: '50%',
    backgroundColor: isDragged ? theme.rawColors.darkGrey300 : theme.rawColors.lightGrey700,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  })
};